/**
 * Aide contextuelle — Pipeline de reconditionnement matériel "by METERIS"
 */

const refurbishmentHelp = {
};

export default refurbishmentHelp;
